import { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import { ShowImageDialog } from "./ShowImageDialog.component";
import { apiURI } from "../ENVs";

export function ViewImage({ productImage, altIndex = 0 }) {
  const [dialog, setDialog] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function loadImage() {
      if (!productImage?.sampleImageURL) return;

      setLoading(true);

      // Blob name is the last path segment of the stored URL (flat name, no folders).
      const blobName = productImage.sampleImageURL
        .split("/")
        .pop()
        .split("?")[0];

      // Fetch through the backend proxy. The default axios instance carries the JWT, so the
      // backend can authenticate and read the blob via Managed Identity over the private
      // endpoint — the storage account never needs public access or CORS.
      const response = await axios.get(`${apiURI}/form/image`, {
        params: { path: blobName },
      });
      if (cancelled) return;

      // Images are stored as JSON { string: base64DataURL }; dual-read keeps any future
      // raw payload working too.
      setData(response.data?.string ?? response.data);
      setLoading(false);
    }

    loadImage().catch((error) => {
      if (!cancelled) {
        console.log({ error });
        setLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [productImage.sampleImageURL]);

  const toggleDialog = () => setDialog(!dialog);

  return (
    <div>
      {loading ? (
        <Skeleton
          variant="rectangular"
          width={150}
          height={150}
          sx={{ borderRadius: 1 }}
        />
      ) : (
        <img
          src={data}
          style={{ maxHeight: "150px" }}
          onClick={toggleDialog}
          alt={`product-img: ${altIndex + 1}`}
        />
      )}
      <br />
      <ShowImageDialog
        data={data}
        dialog={dialog}
        toggleDialog={toggleDialog}
        downloadTimer={!!data}
        imageName={productImage.name}
      />
    </div>
  );
}
